import { v4 as UUIDv4 } from 'uuid'

/**
 * Creates a new, unique session uuid
 * @returns the uuid
 */
const createSessionId = () => UUIDv4()

export default createSessionId
